export default {
      id: "notes-usage",
      viewBox: "0 0 484.665 484.665",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#notes",
      toString: function () {
        return this.url;
      }
    }